export const defaults = {
  margin: {
    top: 30,
    right: 10,
    bottom: 30,
    left: 40,
  },
  width: 480,
  aspectRatio: 1.5,
};

export const months: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function getMonthName(month: number): string {
  return months[month - 1];
}

export function getDate(day: number, month: number, year: number, tz: string): string {
  if (day) {
    return `${day} ${getMonthName(month)} ${year} ${tz}`;
  } else {
    return `${getMonthName(month)} ${year} ${tz}`;
  }
}
